import React from "react";
import TestimonialCard from "../designSystem/TestimonialCard";
import Hero from "../components/Hero";
import HeroImage from "../../assets/images/Testimonials1.jpg";
import FilledButton from "../designSystem/FilledButton";

const testimonials = [
  {
    // title: "Quick and easy mortgage",
    content:
      "We were recommended WPP by a family member and they have been absolutely fantastic from start to finish. Whether it was mortgage advice or any extra advice that he went out his way to offer, Michael was absolutely brilliant to work with, so friendly and approachable and he genuinely had our best interests at heart.",
    author: "Lewis Browning",
  },

  {
    // title: "Quick and easy mortgage",
    content:
      "Very knowledgeable and work their hardest to find the best deal available and provide excellent advice for the future. Fantastic as a company, overall and highest personal compliments to Michael Woolnoth alliant service!",
    author: "Shaun O’Hare",
  },
  {
    // title: "Quick and easy mortgage",
    content:
      "David saved us money and headaches! He explained the process to me and delivered as promised. He gave us choices and as we didn’t need to re new just yet he secured the product so we didn’t lose the better price but ensured we were not tied in until we need to be in case a better price come in…A better price did come in and David managed to save us a little more money. The process was always made easy and we were kept informed of what the changes may be moving forward, would fully recommend.",
    author: "Peter Pole",
  },
  {
    // title: "Quick and easy mortgage",
    content:
      "Just wanted to take a few minutes to say how amazing Conor was! He helped us from our house purchase journey right from the beginning, and although there were a few bumps in the road, he remained efficient and persistent which I believe is a huge reason we managed to secure our dream home!",
    author: "Chloe Hollidge",
  },
  // Add more testimonials as needed
];

const TestimonialsPage = () => {
  return (
    <div className="home-page">
      <Hero
        title="Testimonials"
        titleAlign="center"
        backgroundImage={HeroImage}
        rightImage={HeroImage}
        subtitleAlign="center"
        lightOverlay={true}
      />
      <div className="grey-container">
        <div className="grey-container-content">
          <div className="row centered">
            <FilledButton
              text="Submit a Google Review"
              onClick={() =>
                window.open(
                  "https://www.google.com/maps/place/WPP+Financial+Services/@51.3474047,0.5073837,17z/data=!3m1!5s0x47d8ccd304d36bf1:0x5467cb836a27890c!4m8!3m7!1s0x47d8cdef0249f371:0x2367658a8a285780!8m2!3d51.3474047!4d0.5073837!9m1!1b1!16s%2Fg%2F11gw26qwxn?entry=ttu&g_ep=EgoyMDI2MDQwNi4wIKXMDSoASAFQAw%3D%3D",
                  "_blank",
                )
              }
              //   onClick={() => (window.location.href = "/testimonials")}
            />
            <FilledButton
              text="Submit a Facebook Review"
              onClick={() =>
                window.open(
                  "https://www.facebook.com/wppfs/reviews/?id=100063672725659",
                  "_blank",
                )
              }
              //   onClick={() => (window.location.href = "/testimonials")}
            />
          </div>
        </div>
      </div>
      {/* <div className="white-container">
        <div className="white-container-content">
          <TestimonialCard
            title="Quick and easy mortgage"
            content="Very knowledgeable and work their hardest to find the best deal available and provide excellent advice for the future. Fantastic as a company overall and highest personal compliments to Michael Welton!! Brilliant service!"
            author="Jasmin Magen"
          />
        </div>
      </div> */}
      <div className="burgandy-container">
        <div className="burgandy-container-content">
          <div className="cards-wrapper">
            {testimonials.map((t, idx) => (
              <TestimonialCard key={idx} {...t} />
            ))}
          </div>
        </div>
      </div>
      <div className="white-container">
        <div className="white-container-content">
          <TestimonialCard
            // title="Quick and easy mortgage"
            content="Conor, the man of the hour.
Completed our house purchase, within time, that nearly went sour.
 
Diligent, concise and a pro.
Always there, from the get go!
 
He saw all of the processes through,
Even when the tension grew!
 
Amazing from the start to the end,
Don’t hesitate to use Conor for your mortgage needs,
He’ll arrange the money you want to lend."
            author="Steve And Mark Degiorgio"
          />
          {/* <TestimonialCard
            title="Quick and easy mortgage"
            content="Very knowledgeable and work their hardest to find the best deal available and provide excellent advice for the future. Fantastic as a company overall and highest personal compliments to Michael Welton!! Brilliant service!"
            author="Jasmin Magen"
          /> */}
        </div>
      </div>
    </div>
  );
};

export default TestimonialsPage;
